import { TypeExpertise } from './type-expertise';
import { User } from './user';
import { Contact } from './contact';
import { Prestation } from './prestation';
import * as moment from 'moment';

export class Collaborateur {

  public loading: boolean;

	public id: number;
	public t_hrs: number;
	public t_km: number;
	private _user: User;
  
  	constructor(
  	) {}

    get user(): any {
      return this._user;
    }
    set user(t: any) {
      
      if (typeof t === 'number') {
        this._user = Object.assign((new User),{id: t});
      } else if (t instanceof User ) {
        this._user = t;
      } else {
        this._user = Object.assign((new User),t);
      }
    }    

    public toRequest(): any {
      
      let a = Object.assign({},{
        t_hrs: this.t_hrs,
        t_km: this.t_km,
        user_id: this._user.id
      });
      return a;
    }
}
